module.exports = __webpack_public_path__ + "img/calc-pig.png";